(ns frontend.view.entity-viewers.events.call-editor
  (:require
   [reagent.core :as r]
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [potpuri.core :refer [fn->]]
   [frontend.actions.entity :as entity-actions]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [common.schema.registry :as registry]
   [common.util :as cu]))


(defn call-editor
  [{:keys [state entity-id externally-passed-entity viewed-entity-id on-reset! show-expanded? modal? props
           on-success-callback!]}]
  [editor-utils/editor
   {:state                state
    :always-expanded?     show-expanded?
    :modal?               modal?
    :activity-entity-id   entity-id
    :externally-passed-entity externally-passed-entity
    :viewed-entity-id     viewed-entity-id
    :activity-entity-type :note-call
    :full-width?          true
    :wysiwyg-attribute    :note-call/message
    :placeholder          (loc/tr :call-editor-placeholder)
    :init-draft-state!    (fn [update-draft!]
                            (when viewed-entity-id
                              (update-draft! :common/related-entities #{viewed-entity-id}))
                            (update-draft! :note-call/type :outbound)
                            (update-draft! :note-call/call-made-by (:db/id @session/account))
                            (update-draft! :note-call/timestamp (.getTime (js/Date.))))
    :entity-schema        (registry/get-schema @session/tenant-schema :entity.type/note-call)
    :mandatory-field?     false
    :on-submit!           (fn [data on-success! on-error!]
                            (entity-actions/*->create
                             (-> (cu/remove-nil-vals data)
                                 (assoc :entity/type :entity.type/note-call))
                             (fn [resp]
                               (on-success! resp)
                               (when (fn? on-success-callback!)
                                 (on-success-callback! resp)))
                             on-error!))
    :on-success-callback! on-success-callback!
    :on-reset!            on-reset!
    :submit-button-text   (loc/tr :create-note-call-button)
    :disabled-button-tooltip-text (loc/tr :call-add-one-association)}])
